export interface IResendInvoiceRequest {
  invoiceNumber: string;
  emailAddresses: ResendInvoiceEmail[];
}

export class ResendInvoiceRequest implements IResendInvoiceRequest {
  invoiceNumber: string;
  emailAddresses: ResendInvoiceEmail[];
}

export interface IResendInvoiceEmail {
  emailAddress: string;
  emailAddressId: number;
}

export class ResendInvoiceEmail implements IResendInvoiceEmail {
  emailAddress: string;
  emailAddressId: number;
}
